import gql from "graphql-tag";
const getSamplesQuery = gql(` 
query GetSamples($params: AWSJSON!) {
  getSamples(params: $params) {
  samples
  result
  }
}
`)
export default getSamplesQuery;
